<template>
  <b-card title="تنظیمات 2">
    <b-form >
      <b-row>
        <b-col cols="6">
          <!-- category name-->
          <b-form-group
              label="شماره ورژن"
          >
            <b-form-input
                placeholder="شماره ورژن را وارد کنید"
                v-model="settings.appVersion"
                type="number"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
              label="انتخاب فایل اپلیکیشن  "
          >
            <b-form-file
                v-model="file"
                placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
                drop-placeholder="Drop file here..."
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
              label="آپدیت اجباری"
          >
            <b-form-radio
                v-model="settings.forceUpdate"
                plain
                name="some-radios3"
                value=true
            >
              بله
            </b-form-radio>
            <b-form-radio
                v-model="settings.forceUpdate"
                plain
                name="some-radios3"
                value=false
            >
              خیر
            </b-form-radio>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
              label="استفاده از نرم‌افزار به صورت"
          >
           <b-form-checkbox
              v-model="settings.paymentIsActive"
              checked="true"
              name="check-button"
              switch
              inline
            >
              {{ !settings.paymentIsActive ? 'رایگان' : 'پولی' }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
              label="استفاده آزمایشی از نرم‌افزار"
          >
           <b-form-checkbox
              v-model="settings.trialIsActive"
              checked="true"
              name="check-button"
              switch
              inline
            >
              {{ settings.trialIsActive ? 'فعال' : 'غیرفعال' }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            v-if="settings.trialIsActive"
            label="تعداد روزهای استفاده آزمایشی"
          >
            <b-form-input
                placeholder="تعداد روزها را وارد کنید"
                v-model="settings.trialDays"
                type="number"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
              label="آدرس اشتراک گذاری برنامه برای کاربران اندروید"
          >
            <b-form-input
                placeholder="آدرس را وارد کنید"
                v-model="settings.androidShareUrl"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
              label="آدرس اشتراک گذاری برنامه برای کاربران ios"
          >
            <b-form-input
                placeholder="آدرس را وارد کنید"
                v-model="settings.iosShareUrl"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
              label="آدرس صفحه درباره ما"
          >
            <b-form-input
                placeholder="آدرس را وارد کنید"
                v-model="settings.aboutUrl"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
              label="آدرس صفحه ارتباط با ما"
          >
            <b-form-input
                placeholder="آدرس را وارد کنید"
                v-model="settings.contactUrl"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6" class="mb-1">
          <b-form-group
            label="انتخاب آیکون صفحه درباره ما"
          >
            <b-form-file
              placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
              drop-placeholder="Drop file here..."
              accept=".jpg,.svg, .png"
              @change="handleAboutImage($event)"
            />
          </b-form-group>

          <div class="image-preview">
            <b-img :src="aboutImagePreview" v-show="showAboutImagePreview" fluid/>
          </div>
        </b-col>
        <b-col cols="6" class="mb-1">
          <b-form-group
            label="انتخاب آیکون صفحه ارتباط با ما"
          >
            <b-form-file
              placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
              drop-placeholder="Drop file here..."
              accept=".jpg,.svg, .png"
              @change="handleContactImage($event)"
            />
          </b-form-group>

          <div class="image-preview">
            <b-img :src="contactImagePreview" v-show="showContactImagePreview" fluid/>
          </div>
        </b-col>
        <b-col cols="6" class="mb-1">
          <b-form-group
            label="انتخاب لوگو صفحه اسپلش"
          >
            <b-form-file
              placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
              drop-placeholder="Drop file here..."
              accept=".jpg,.svg, .png"
              @change="handleSplashImage($event)"
            />
          </b-form-group>

          <div class="image-preview">
            <b-img :src="splashImagePreview" v-show="showSplashImagePreview" fluid/>
          </div>
        </b-col>
        <b-col cols="6" class="mb-1">
          <b-form-group
            label="انتخاب لوگو صفحه اصلی"
          >
            <b-form-file
              placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
              drop-placeholder="Drop file here..."
              accept=".jpg,.svg, .png"
              @change="handleMainImage($event)"
            />
          </b-form-group>

          <div class="image-preview">
            <b-img :src="mainImagePreview" v-show="showMainImagePreview" fluid/>
          </div>
        </b-col>
        <b-col cols="6" class="mb-1">
          <b-form-group
            label=" انتخاب رنگ منوی اصلی"
            label-for="main-color"
          >
            <color-picker v-model="settings.appColors[0].value"></color-picker>
            <div class="selected-color-info">
              <p>رنگ انتخاب شده</p>
              <svg height="32" width="32">
                <circle cx="16" cy="16" r="15" :fill="settings.appColors[0].value"/>
              </svg>
            </div>
            <p>
              Color:
              <b-form-input
                  id="v-color"
                  placeholder="کد رنگ را به صورت hex وارد کنید"
                  v-model="settings.appColors[0].value"
              />
            </p>
          </b-form-group>
        </b-col>
        <b-col cols="6" class="mb-1">
           <b-form-group
            label=" انتخاب رنگ بالای منوی کناری"
            label-for="main-color"
          >
            <color-picker v-model="settings.appColors[1].value"></color-picker>
            <div class="selected-color-info">
              <p>رنگ انتخاب شده</p>
              <svg height="32" width="32">
                <circle cx="16" cy="16" r="15" :fill="settings.appColors[1].value"/>
              </svg>
            </div>
            <p>
              Color:
              <b-form-input
                  id="v-color"
                  placeholder="کد رنگ را به صورت hex وارد کنید"
                  v-model="settings.appColors[1].value"
              />
            </p>
          </b-form-group>
        </b-col>
   
        <b-col cols="12">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="mr-1"
              @click="editSettings"
              variant="primary"
          >
            ثبت
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BCol,
  BFormFile,
  BForm,
  BFormCheckbox,
  BImg,
  BFormSelect,
    BFormRadio,
  BFormGroup,
  BCardTitle,
  BCardSubTitle,
  BCardText,
  BFormInput,
  BLink,
  BCard,
  BRow,
  BCardBody
} from "bootstrap-vue";
import Croppa from 'vue-croppa'
import Vue from "vue";
import videoFormComponent from "@/modules/contents/add/videoFormComponent";
import ColorPicker from 'vue-color-picker-wheel';
import settingsRepository from "@/modules/settings/services/settingsRepository";
import uploadService from "@/modules/services/uploadService";
import Swal from "sweetalert2";
Vue.use(Croppa);



export default {
  name: "editSettings",
  created() {
    this.getSettings()
  },
  components: {
    BCard,
    BFormSelect,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BCardBody,
    BCardSubTitle,
    BFormRadio,
    BCardTitle,
    BCardText,
    BImg,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormFile,
    ColorPicker,
    videoFormComponent
  },
  data(){
    return {
      settings: {
        paymentIsActive: false,
        forceUpdate: false,
        appLink: "",
        appVersion: 0,
        trialIsActive: false,
        trialDays: 0,
        splashLogoUrl: "",
        mainLogoUrl: "",
        androidShareUrl: "",
        iosShareUrl: "",
        aboutUrl: "",
        contactUrl: "",
        aboutIcon: "",
        contactIcon: "",
        appColors: [
          {
            key: "MainMenu",
            value: "#000000"
          },
          {
            key: "DrawerMenu",
            value: "#000000"
          },
        ]
      },
      file: undefined,
      mainLogofile: undefined,
      splashLogofile: undefined,
      contactIconFile: undefined,
      splashImagePreview: false,
      showSplashImagePreview: false,
      mainImagePreview: false,
      showMainImagePreview: false,
      aboutImagePreview: false,
      showAboutImagePreview: false,
      contactImagePreview: false,
      showContactImagePreview: false,
    }
  },
  methods: {
    async getSettings() {
      const {data} = await settingsRepository.get('');

      if (data.isSuccess){
        let colors = [
          {
            key: "MainMenu",
            value: "#000000"
          },
          {
            key: "DrawerMenu",
            value: "#000000"
          },]
        data.data.appColors.map(item => {
          item.key === this.settings.appColors[0].key ? colors[0].value = item.value :
          item.key === this.settings.appColors[1].key ? colors[1].value = item.value : null
        })
        this.settings = {...data.data, appColors: colors}
      }
    },

    handleSplashImage(event) {
      this.splashLogofile = event.target.files[0]

      let reader = new FileReader()
      reader.addEventListener('load', function () {
        this.showSplashImagePreview = true
        this.splashImagePreview = reader.result
        this.$emit('imageChanged',  this.splashLogofile )
      }.bind(this), false)

      if ( this.splashLogofile ) {
        if (/\.(jpe?g|png|svg)$/i.test( this.splashLogofile.name)) {
          reader.readAsDataURL( this.splashLogofile )
        }
      }
    },
    handleMainImage(event) {
      this.mainLogofile = event.target.files[0]

      let reader = new FileReader()
      reader.addEventListener('load', function () {
        this.showMainImagePreview = true
        this.mainImagePreview = reader.result
        this.$emit('imageChanged', this.mainLogofile)
      }.bind(this), false)

      if (this.mainLogofile) {
        if (/\.(jpe?g|png|svg)$/i.test(this.mainLogofile.name)) {
          reader.readAsDataURL(this.mainLogofile)
        }
      }
    },
    handleAboutImage(event) {
      this.settings.aboutIcon = event.target.files[0]

      let reader = new FileReader()
      reader.addEventListener('load', function () {
        this.showAboutImagePreview = true
        this.aboutImagePreview = reader.result
        this.$emit('imageChanged', this.settings.aboutIcon)
      }.bind(this), false)

      if (this.settings.aboutIcon) {
        if (/\.(jpe?g|png|svg)$/i.test(this.settings.aboutIcon.name)) {
          reader.readAsDataURL(this.settings.aboutIcon)
        }
      }
    },
    handleContactImage(event) {
      this.contactIconFile = event.target.files[0]

      let reader = new FileReader()
      reader.addEventListener('load', function () {
        this.showContactImagePreview = true
        this.contactImagePreview = reader.result
        this.$emit('imageChanged', this.contactIconFile)
      }.bind(this), false)

      if (this.contactIconFile) {
        if (/\.(jpe?g|png|svg)$/i.test(this.contactIconFile.name)) {
          reader.readAsDataURL(this.contactIconFile)
        }
      }
    },

    async editSettings() {
      if (this.file) {
        this.settings.appLink = await uploadService.upload(this.file);
       
      }
      if (this.mainLogofile) {
        this.settings.mainLogoUrl = await uploadService.upload(this.mainLogofile);
      }

      if (this.splashLogofile) {
        this.settings.splashLogoUrl = await uploadService.upload(this.splashLogofile);
      }
      if (this.contactIconFile) {
        this.settings.contactIcon = await uploadService.upload(this.contactIconFile);
      }
      this.settings.trialDays = +this.settings.trialDays;
      const {data} = await settingsRepository.CreateAndUpdate(this.settings);

      try {
        if (data.isSuccess){
          await Swal.fire({
            confirmButtonText: 'ok',
            title : 'موفقیت',
            html : 'عملیات با موفقیت انجام شد',
            icon: 'success'
          });
          await this.$router.replace('/')
        }else {
          await Swal.fire('هشدار', data.message, 'warning');
        }
      }catch (e){
        await Swal.fire('خطا', 'مشکلی پیش آمده لطفا با پشتیبانی تماس بگیرید', 'error');
      }
    },
  }
}
</script>

<style scoped>


.croppa-container {
  background-color: #c3c3c3;
  border: 2px solid grey;
  border-radius: 8px;
}

.croppa-container:hover {
  opacity: 1;
  background-color: #8ac9ef;
}

#color-wheel {
  margin-left: auto;
  margin-right: auto;
}

.selected-color-info {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.selected-color-info p {
  margin: 0 5px 0 0;
}

</style>
